WebFont.load({
    google: {
        families: ['Tangerine:bold', 'Josefin Sans:regular', 'Questrial:regular', 'Sacramento:regular']
    },
    custom: {
        families: ['FontAwesome'],
        urls: ['https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.4.0/css/font-awesome.min.css']
    }
});